import PortfolioConfigData from "config/portfolio-config.json";
import React from "react";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import { useTranslation } from "react-i18next";
// import SimulazioneAndamento from "./components/SimulazioneAndamento";
import SimulazionePerformance from "./components/SimulazionePerformance";
import SimulazioneGraficoVolatilita from "./components/SimulazioneGraficoVolatilita";
import RendimentiCumulatiPerHoldingPeriod from "./components/RendimentiCumulatiPerHoldingPeriod";
import DistribuzioneRendimenti1y from "./components/DistribuzioneRendimenti1y";
import SimulazioneAndamentoPortafoglio from "./components/SimulazioneAndamentoPortafoglio";
import SimulazionePerformanceCompare from "../../compare/components/SimulazionePerformanceCompare";
import AnalisiDrawdownBacktestTable from "./components/AnalisiDrawdownBacktestTable";
import AnalisiDrawdownBacktestAndamentoPortafoglio from "./components/AnalisiDrawdownBacktestAndamentoPortafoglio";
import SimulazioneRendimentiAnnoSolare from "./components/SimulazioneRendimentiAnnoSolare";
import RendimentiCumulatiPerHoldingPeriodTable from "./components/RendimentiCumulatiPerHoldingPeriodTable";
import ViolazioneMaxPerditaMaxGuadagno from "./components/ViolazioneMaxPerditaMaxGuadagno";
import StressDelPortafoglio from "./components/StressDelPortafolioSuIpotesiStoriche";
import AnalisiDrawdownPortfolioCompare from "../../compare/components/backtest/AnalisiDradownPortfolioCompare";
import AnalisiDrawdownChartsCompare from "../../compare/components/backtest/AnalisiDrawdownChartsCompare";
import SimulazioneRendimentiAnnoSolareCompare from "../../compare/components/backtest/SimulazioneRendimentiAnnoSolareCompare";
import SimulazioneGraficoVolatilitaCompare from "../../compare/components/backtest/SimulazioneGraficoVolatilitaCompare";
import ViolazioneMaxPerditaMaxGuadagnoCompare from "../../compare/components/backtest/ViolazioneMaxPerditaMaxGuadagnoCompare";
import StressDeiPortafogliScenariNegativiCompare from "../../compare/components/backtest/StressDeiPortafogliScenariNegativiCompare";
import colorsStore from "shared/store/colorsStore";

type SectionChildrenProps = { reportData: any; reportData2?: any };
const BacktestContainer: React.FC<SectionChildrenProps> = ({
  reportData,
  reportData2,
}) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const { t } = useTranslation();
  if (!reportData) {
    return <></>;
  }

  return (
    <>
      {!reportData2 && (
        <div
          className={commonStyles.sectionContainer}
          style={{ marginBottom: 10 }}
        >
          <SimulazioneAndamentoPortafoglio
            data={reportData}
            title={t("portfolio.simulazioneAndamentoPortfolio")}
          />
          <SimulazionePerformance
            data={reportData}
            title={t("portfolio.simulazione_performance_title")}
          />
          <AnalisiDrawdownBacktestTable
            data={reportData}
            title={t("portfolio.analisiDrawdown")}
          />
          <AnalisiDrawdownBacktestAndamentoPortafoglio data={reportData} />
          <SimulazioneRendimentiAnnoSolare data={reportData} />
          <SimulazioneGraficoVolatilita data={reportData} />
          <RendimentiCumulatiPerHoldingPeriod
            data={reportData}
            title={t("portfolio.rendimentiCumulatiDelPortafoglio")}
            mainColor={colorsConfig.FinecoBluePrimary}
            mainColorFill={colorsConfig.finecoBlueLight}
          />
          <RendimentiCumulatiPerHoldingPeriodTable data={reportData} />
          <DistribuzioneRendimenti1y data={reportData} />
          <ViolazioneMaxPerditaMaxGuadagno
            data={reportData}
            title={t("portfolio.violazioniMaxPerditaMaxGuadagno")}
          />
          <StressDelPortafoglio data={reportData} mood="negative" />
          <StressDelPortafoglio data={reportData} mood="positive" />
        </div>
      )}
      {reportData2 && (
        <div
          className={commonStyles.sectionContainer}
          style={{ marginBottom: 10 }}
        >
          <SimulazioneAndamentoPortafoglio
            data={reportData}
            data2={reportData2}
            title={t("portfolio.simulazioneAndamentoPortfolioCompare")}
          />
          <SimulazionePerformanceCompare
            data={reportData}
            data2={reportData2}
            title={t("portfolio.simulazione_performance_titleCompare")}
          />
          <div className="force-page-break"></div>
          <AnalisiDrawdownPortfolioCompare
            data={reportData}
            data2={reportData2}
            title={t("portfolio.analisiDrawdown")}
          />
          <AnalisiDrawdownChartsCompare data={reportData} data2={reportData2} />
          <div className="force-page-break"></div>
          <SimulazioneRendimentiAnnoSolareCompare
            data={reportData}
            data2={reportData2}
          />
          <SimulazioneGraficoVolatilitaCompare
            data={reportData}
            data2={reportData2}
          />
          <div className="force-page-break"></div>
          <RendimentiCumulatiPerHoldingPeriod
            data={reportData}
            title={t("portfolio.rendimentiCumulatiDelPortafoglio1")}
            mainColor={colorsConfig.portfolio1}
            mainColorFill={"#CFD7E4"}
          />

          <RendimentiCumulatiPerHoldingPeriodTable
            data={reportData}
            title={t("portfolio.orizzonteTemporale")}
          />
          <div className="force-page-break"></div>
          <RendimentiCumulatiPerHoldingPeriod
            data={reportData2}
            title={t("portfolio.rendimentiCumulatiDelPortafoglio2")}
            mainColor={colorsConfig.portfolio2}
            mainColorFill={"#D6ECF0"}
          />
          <RendimentiCumulatiPerHoldingPeriodTable
            data={reportData2}
            title={t("portfolio.orizzonteTemporale")}
          />
          <div className="force-page-break"></div>
          <DistribuzioneRendimenti1y
            data={reportData}
            colorBarChart={colorsConfig.FinecoBlueDark}
            isCompareTitle={t("portfolio.distribuzioneRendimenti1y")}
            isCompareSubtitle={t("portafoglioCompare.portafoglio1")}
          />
          <DistribuzioneRendimenti1y
            data={reportData2}
            colorBarChart={colorsConfig.portfolio2}
            isCompareSubtitle={t("portafoglioCompare.portafoglio2")}
          />
          <div className="force-page-break"></div>
          <ViolazioneMaxPerditaMaxGuadagnoCompare
            data={reportData}
            data2={reportData2}
            title={t("portfolio.violazioniMaxPerditaMaxGuadagno")}
          />
          <div className="force-page-break"></div>
          <StressDeiPortafogliScenariNegativiCompare
            reportData={reportData}
            reportData2={reportData2}
          />
        </div>
      )}
    </>
  );
};
export default React.memo(
  BacktestContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    return prevProps.reportData === nextProps.reportData;
  },
);
